import { Component, Input, TemplateRef } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';

import { RegistrationRowsEditor } from '../registration-rows-editor';

/**
 * Mobile layout for a fill-in `FormArray`: the add button, the open editor and the
 * collapsed cards. The editor and the card stay as `ng-template`s on the page so
 * their fields keep static `i18n` attributes and resolve `formGroupName` against the
 * page's `formArrayName`.
 */
@Component({
  selector: 'registration-entry-list',
  templateUrl: './registration-entry-list.component.html',
})
export class RegistrationEntryListComponent {
  @Input()
  rows: UntypedFormArray;

  @Input()
  editor: RegistrationRowsEditor;

  @Input()
  editorTemplate: TemplateRef<any>;

  @Input()
  cardTemplate: TemplateRef<any>;

  @Input()
  addLabel = '';

  @Input()
  addDisabled = false;
}
